import { useEffect, useState } from 'react';

import { Device } from '@device/Device';
import { getDevice } from '@device/getDevice';

interface UseGetDeviceProps {
  device: Device;
  isMobile: boolean;
  isDesktop: boolean;
}

const useGetDevice = (): UseGetDeviceProps => {
  const [currentDevice, setCurrentDevice] = useState<Device>(getDevice());

  useEffect(() => {
    const handleResize = () => {
      setCurrentDevice(getDevice());
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = currentDevice === Device.MOBILE;
  const isDesktop = currentDevice === Device.DESKTOP;

  return {
    device: currentDevice,
    isMobile,
    isDesktop,
  };
};

export default useGetDevice;
